import React from "react";

const Loading = () => (
  <div className="sg-mgmt-loading-container">
    <div className="sg-mgmt-loading" />
  </div>
);

export default Loading;
